import { render } from "./ContactCardPermission.vue?vue&type=template&id=71173729"
import script from "./ContactCardPermission.vue?vue&type=script&lang=js"
export * from "./ContactCardPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__